<template>
  <slot v-if="allowed" />
  <NeedSub v-else class="lock" @close="$emit('close')">
    <div class="lock-slot">
      <div class="lock-inner"><slot /></div>
      <LockIcon class="lock-badge" />
    </div>
  </NeedSub>
</template>

<script setup>
import { computed, defineEmits } from "vue";
import { useStore } from "vuex";
import NeedSub from "../modal/NeedSub.vue";
import LockIcon from "./icons/Lock.vue";

// A-11: замок на недоступной функции. Контрол виден, но заблокирован;
// клик проваливается на обёртку NeedSub (модалка A-12). Иконка замка — bottom-right.
defineEmits(["close"]);

const props = defineProps({
  permission: {
    type: String,
    required: true,
  },
});

const store = useStore();
const allowed = computed(() => store.getters.hasPermission(props.permission));
</script>

<style scoped>
.lock-slot {
  position: relative;
  display: inline-flex;
}
/* контрол виден, но клики «проваливаются» сквозь него на обёртку NeedSub */
.lock-inner {
  display: inline-flex;
  pointer-events: none;
}
/* фиксированный размер: вокруг контролы с разным font-size
   (12px у тегов, крупнее в шапке матча) */
.lock-slot > .lock-badge {
  position: absolute;
  right: -1px;
  bottom: -1px;
  width: 12px;
  height: 12px;
  color: var(--back-color);
  /* штрих масштабируется вместе с иконкой: чтобы бейдж 12px выглядел так же
     жирно, как замок ~17px в шапке */
  stroke-width: 2.8;
  pointer-events: none;
}
</style>
